import React, { createContext, useEffect, useState, useContext } from "react";
import config from "../config";
export const RechtenContext = createContext();

export const RechtenProvider = ({ children }) => {
  const [rechten, setRechten] = useState(null);
  const [loading, setLoading] = useState(true);
  const [huidigeUPN, setHuidigeUPN] = useState(null); 

  useEffect(() => {
    const fetchRechten = async () => {
      try {
        const token = sessionStorage.getItem("access_token");
        const res = await fetch(`${config.API_URL}/mijnrechten`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (res.ok) {
          const data = await res.json();
          setRechten(data);
          setHuidigeUPN(data?.UPN?.trim().toLowerCase() || null); // 🔸 toegevoegd
        } else {
          setRechten({});
        }
      } catch (err) {
        console.error("❌ Rechten ophalen mislukt:", err);
        setRechten({});
        setHuidigeUPN(null);
      } finally {
        setLoading(false);
      }
    };

    fetchRechten();
  }, []);

  return (
    <RechtenContext.Provider value={{ rechten, loading, huidigeUPN }}>
      {children}
    </RechtenContext.Provider>
  );
};

export const useRechten = () => useContext(RechtenContext);
